import { matchIsValidTel } from 'mui-tel-input';
import { z } from 'zod';

// Phone validation schema
export const phoneSchema = z
  .string()
  .refine(
    val => matchIsValidTel(val, { onlyCountries: ['US', 'CA', 'GB', 'AU', 'NZ', 'ZA', 'MX'] }),
    { message: 'Please enter a valid phone number' },
  );

// Email validation schema
export const emailSchema = z.string().email('Please enter a valid email address');

// Date of birth validation schema
export const dobSchema = z
  .string()
  .min(1, 'Date of birth is required')
  .refine(val => {
    const date = new Date(val);
    const today = new Date();
    return date <= today;
  }, 'Date of birth cannot be in the future')
  .refine(val => {
    const date = new Date(val);
    const minDate = new Date('1900-01-01');
    return date >= minDate;
  }, 'Please enter a valid date of birth');

// Validation helper functions
export const validatePhone = (phone: string): { isValid: boolean; error?: string } => {
  const result = phoneSchema.safeParse(phone);
  return result.success
    ? { isValid: true }
    : { isValid: false, error: result.error.errors[0]?.message || 'Invalid phone number' };
};

export const validateEmail = (email: string): { isValid: boolean; error?: string } => {
  const result = emailSchema.safeParse(email);
  return result.success
    ? { isValid: true }
    : { isValid: false, error: result.error.errors[0]?.message || 'Invalid email address' };
};

export const validateDob = (dob: string): { isValid: boolean; error?: string } => {
  const result = dobSchema.safeParse(dob);
  return result.success
    ? { isValid: true }
    : { isValid: false, error: result.error.errors[0]?.message || 'Invalid date of birth' };
};